import styled from 'styled-components';
import { FormInput } from 'components/common/json_form';
import { CEB_COLOR, CEB_COLOR_RGBA } from 'app-constants/CEB_COLOR';

export const StyledFormInputError = styled(FormInput)`
  input {
    border: 1px solid ${CEB_COLOR('TUSCANY')};
  }
`;

export const StyledFormInput = styled(FormInput)`
  margin-bottom: 22px;

  label {
    display: block;
  }

  input,
  select,
  input[type='text'],
  input[type='search'],
  input[type='email'],
  input[type='password'],
  textarea {
    background: white;
    border-color: ${CEB_COLOR('GALLERY')};
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    box-sizing: border-box;
    display: block;
    font-size: 16px;
    font-weight: bold;
    padding: 12px 15px 14px 15px;
    width: 100%;
    &::placeholder {
      color: ${CEB_COLOR_RGBA('LUCKY_POINT', 0.5)};
    }
    &[data-invalid] {
      color: ${CEB_COLOR('TUSCANY')};
      border-color: ${CEB_COLOR('TUSCANY')};
    }
  }

  select {
    padding: 11px 14px 13px 14px;
  }

  .label-text {
    font-size: 15px;
    display: block;
  }

  .hint-text {
    display: block;
    margin: 0.5em 0;
    font-style: italic;
    font-size: 0.8em;
  }

  &.invalid,
  &.error {
    input {
      border: 1px solid ${CEB_COLOR('TUSCANY')};
    }
  }
`;

export const StyledFormButton = styled.button`
  background: ${CEB_COLOR('NICE_BLUE')};
  border-radius: 3px;
  font-family: 'BasisGrotesque', sans-serif;
  font-size: 16px;
  font-weight: normal;
  padding: 12px 48px 10px;
  width: 55%;
  cursor: pointer;
  color: #fff;
  &:visited {
    color: #fff;
  }
  &[type='cancel'] {
    background-color: ${CEB_COLOR('COOL_BLUE')};
  }
  &[disabled] {
    background-color: ${CEB_COLOR('DOVE_GRAY')};
    cursor: default;
  }
`;
